module.exports = __webpack_public_path__ + "img/102.3.7f983df3.png";